<template>
    <modal-centered-base
    fullScreenDialog
    rightButtonIcon="check-line"
    :titleIcon="modalParams.titleIcon || 'pencil'"
    :positionAbsoluteToElement="positionAbsoluteToElement"
    :modalWidth="modalWidth"
    :triggerClose="triggerClose"
    :title="modalParams.title"
    :rightButtonText="t('modals.saveBtn')"
    :rightButtonDisabled="modalParams.rightButtonDisabled"
    @hideMe="emit('hideMe')"
    @allowPortalElementsToBeRender="allowPortalElementsToBeRender = $event"
    @rightButtonClicked="requestHandler">
        <input-generic
        :key="allowPortalElementsToBeRender"
        :focusInput="focusInput && allowPortalElementsToBeRender"
        :class="{'mobile': getMobileAppState }"
        :params="{...modalParams, labelText: modalParams.label || modalParams.labelText }"
        :inputValue="inputValue"
        @input="[inputValue = $event, emit('input', $event)]"/>
    </modal-centered-base>
    <!-- Loader -->
    <loader-generic v-if="showLoader" isOverlay/>
    <!-- Feedback Toast -->
    <toast-generic
    v-if="showToast"
    :feedbackText="feedbackToastParams.text"
    :toastType="feedbackToastParams.toastType"
    @hideMe="showToast = false"/>
</template>

<script setup>
/* Components */
import ModalCenteredBase from '@/components/generic/modals/centered/Base'
import InputGeneric from '@/components/generic/inputs/Generic'
import LoaderGeneric from '@/components/generic/loaders/Generic'
import ToastGeneric from '@/components/generic/toasts/Generic'

/* Vue */
import { ref } from 'vue'

/* Store */
import store from '@/store/store'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'input', 'requestSuccessful', 'applyMandatoryFieldError'])

/* Props
@modalParams {Object}
    - labelText { String}
    - title { String}
    - content {String, Number}
	- mandatory { Boolean }
	- errorState { Boolean }
    - maxLength {String, Number}
    - editAction  {String }
    - showCounter {Boolean}
    - rightButtonDisabled { Boolean }
@triggerClose {Boolean} - prop to trigger close of modal
@editAction {String} - action function name
@positionAbsoluteToElement {Boolean}
@modalWidth {String}
@focusInput {Boolean} - prop to trigger input focus
*/
const props = defineProps({
	modalParams: Object,
    requestPayload: Object,
    triggerClose: Boolean,
    positionAbsoluteToElement: Boolean,
    modalWidth: String,
    focusInput: Boolean
})

const { getMobileAppState } = mapGetters()

const showLoader = ref(false)
const triggerClose = ref(false)
const inputValue = ref(props.modalParams.content)
const allowPortalElementsToBeRender = ref(false)

/*************************************************
*                                                *
*                  Request Logic              *
*                                                *
*************************************************/
const requestHandler = async () => {
    if (props.modalParams.mandatory && !inputValue.value.length) {
        emit('applyMandatoryFieldError')
        return
    }
    showLoader.value = true

    const payload = { ...props.requestPayload }

    try {
        const res = await store.dispatch(props.modalParams.editAction, payload)

        emit('requestSuccessful', res.data)
        triggerClose.value = true
    } catch (error) {
        showToastHandler(error.response && error.response.data ? error.response.data : { errorLevel: 'error' })
    }
}

/*************************************************
*                                                *
*               Feedback Toast Logic             *
*                                                *
*************************************************/
const showToast = ref(false)
const feedbackToastParams = ref({ text: '', toastType: 'info' })

const showToastHandler = response => {
    showLoader.value = false

    feedbackToastParams.value = {
        text: response.message || t('genericErrorMessage'),
        toastType: response.errorLevel.toLowerCase() === 'error' ? 'negative' : response.errorLevel.toLowerCase()
    }
    showToast.value = true
}
</script>

<style lang="scss" scoped>
.input-elements-container {
    margin-top: 16px;

    &.mobile {
        margin-top: 0;
    }
}
</style>
